import { Cryptocurrencies } from "../../components";

function CryptocurrenciesPage() {
   return <Cryptocurrencies />;
}

export default CryptocurrenciesPage;
